// extracted by mini-css-extract-plugin
export default {"FModalBody":"FModalBody___UmxQq","tip":"tip___Ib2Cx","wrapClassName":"wrapClassName___AARDA","FInput":"FInput___bg0k6","errorTip":"errorTip___tyTZL"};